import { Middleware } from "@reduxjs/toolkit";
import {
  pickPersistedUserSettings,
  savePersistedUserSettings,
} from "./userSettingsStorage";

const PREFERENCE_ACTIONS = new Set([
  "userInfo/updateTimerSound",
  "userInfo/updateSoundEffects",
  "userInfo/updateFontSize",
  "userInfo/updateContrast",
  "userInfo/updateShowPictures",
  "userInfo/loadSettingsFromStorageAction",
]);

export const localStorageMiddleware: Middleware =
  (store) => (next) => (action) => {
    const result = next(action);

    const actionType =
      typeof action === "object" &&
      action !== null &&
      "type" in action &&
      typeof (action as { type: unknown }).type === "string"
        ? (action as { type: string }).type
        : null;

    if (actionType && PREFERENCE_ACTIONS.has(actionType)) {
      savePersistedUserSettings(
        pickPersistedUserSettings(store.getState().userInfo),
      );
    }

    return result;
  };
